import { useEffect } from "react";

const keycloakEnabled = process.env.REACT_APP_KEYCLOAK_ENABLED === "true";
const api = process.env.REACT_APP_API_URL;

let eventSource = new EventSource(api + "/broadcast-event");
const UseSSEHook = () => {
  useEffect(() => {
    if (!keycloakEnabled) return;

    const handleOpen = () => {
      console.log("connection established");
    };

    const handleError = (error) => {
      console.log("connection error");
      eventSource.close();

      setTimeout(() => {
        // Reconnect with exponential backoff
        eventSource = new EventSource(api + "/broadcast-event");
      }, 5000);
    };

    eventSource.onmessage = (event) => {

      if (event.data && event.data !== "{}" && event.data !== "connected") {
        const sessions = JSON.parse(event.data);
        if (sessions && sessions[window?.keycloak?.sessionId]) {
          console.log("session found:", sessions[window?.keycloak?.sessionId]);
          fetch(
            api +
              "/remove-event?sessionId=" +
              sessions[window?.keycloak?.sessionId],
          ).then((r) => {
            r.json().then((data) => {
              window.keycloak.logout().then((result) => {
                console.log({ result });
              });
            });
          });
        }
      }
    };

    eventSource.onopen = handleOpen;
    eventSource.onerror = handleError;

    return () => {
      eventSource.close();
    };
  }, []);
};

export default UseSSEHook;
